export default function vh() {
  return window.innerHeight * 0.01;
}
